import React, { useState, useEffect, useRef } from 'react'
import styles from './VisitorStats.module.scss'
import { UsersOnlineIcon, ChartUpIcon } from 'components/CustomIcons'
import { getVisitorStats } from 'service/VisitorStatsService'
import { FaTelegram } from 'react-icons/fa'

const VisitorStats = () => {
  const [stats, setStats] = useState({
    online_count: 0,
    total_visits: 0
  })
  const [isLoading, setIsLoading] = useState(true)
  const [countdown, setCountdown] = useState(30)
  const intervalRef = useRef(null)
  const countdownRef = useRef(null)

  const fetchStats = async () => {
    try {
      const data = await getVisitorStats()
      if (data) {
        setStats({
          online_count: data.online_count || 0,
          total_visits: data.total_visits || 0
        })
      }
      setIsLoading(false)
    } catch (error) {
      console.error('Failed to fetch visitor stats:', error)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    // Initial fetch
    fetchStats()

    // Poll every 30 seconds
    intervalRef.current = setInterval(() => {
      fetchStats()
      setCountdown(30)
    }, 30000)

    // Countdown timer every second
    countdownRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) return 30
        return prev - 1
      })
    }, 1000)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
      if (countdownRef.current) {
        clearInterval(countdownRef.current)
      }
    }
  }, [])

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M'
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K'
    }
    return num.toString()
  }

  return (
    <div className={styles.visitorStats}>
      <div 
        className={styles.statBlock}
      >
        <div className={styles.iconWrapper}>
          <UsersOnlineIcon size={28} className={styles.icon} />
        </div>
        <div className={styles.statContent}>

      <div className={styles.countdown}>
        <span className={styles.countdownText}>{countdown}s</span>
      </div>
          <div className={styles.statValue}>{formatNumber(stats.online_count)}</div>
          <div className={styles.statLabel}>Онлайн</div>
        </div>
        <div className={styles.modalTooltip}>
          Сейчас онлайн: {stats.online_count}
        </div>
      </div>

      <div 
        className={styles.statBlock}
        style={{ cursor: 'help' }}
      >
        <div className={styles.iconWrapper}>
          <ChartUpIcon size={28} className={styles.icon} />
        </div>
        <div className={styles.statContent}>
          <div className={styles.statValue}>{formatNumber(stats.total_visits)}</div>
          <div className={styles.statLabel}>Визитов</div>
        </div>
        <div className={styles.modalTooltip}>
          Всего визитов: {stats.total_visits.toLocaleString()}
        </div>
      </div>

      <a 
        href="https://t.me/kyrgyz_cybersport_federation" 
        target="_blank" 
        rel="noopener noreferrer"
        className={styles.statBlock}
        style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
      >
        <div className={styles.iconWrapper}>
          <FaTelegram size={28} className={styles.icon} style={{ color: '#24A1DE' }} />
        </div>
        <div className={styles.statContent}>
          <div className={styles.statValue}>TG</div>
          <div className={styles.statLabel}>Канал</div>
        </div>
        <div className={styles.modalTooltip}>
          Перейти в Telegram канал
        </div>
      </a>
    </div>
  )
}

export default VisitorStats
